import React from "react";
import { Organization } from "../../../hooks/rebuildBackendFetchHooks";
import { FilterableSelectGeneric } from "../../../pages/components/GenericInputComponents";


interface OrganizationSelectorProps {
	organizations: Organization[];
	selectedOrganization: Organization | undefined;
	onSelect: (organization: Organization | undefined) => void;
	label?: string;
}

const OrganizationSelector: React.FC<OrganizationSelectorProps> = ({ organizations, selectedOrganization, onSelect: _onSelect, label = "Customer Name" }) => {
	const onSelect = (organization: Organization | undefined) => {
		_onSelect(organization);
	};

	return (
		<div>
			<label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
			<FilterableSelectGeneric
				options={organizations}
				onSelect={onSelect}
				value={selectedOrganization}
				disabled={!organizations?.length}
				placeholder={"Customer Name"}
				getDisplayValue={(organization) => organization.organizationName ?? ""}
				getKey={(organization) => organization.organizationId}
			/>
		</div>
	);
};

export default OrganizationSelector;
